var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDynamicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.175 18.375H6.06495C5.53486 18.375 5.26982 18.375 5.14709 18.2702C5.04059 18.1792 4.98408 18.0428 4.99507 17.9032C5.00773 17.7423 5.19515 17.5549 5.56998 17.18L13.0101 9.73995C13.3566 9.39344 13.5298 9.22018 13.7296 9.15526C13.9053 9.09816 14.0947 9.09816 14.2704 9.15526C14.4702 9.22018 14.6434 9.39343 14.9899 9.73995L18.375 13.125V14.175M14.175 18.375C15.6451 18.375 16.3802 18.375 16.9417 18.0889C17.4357 17.8372 17.8372 17.4357 18.0889 16.9417C18.375 16.3802 18.375 15.6451 18.375 14.175M14.175 18.375H6.825C5.35486 18.375 4.61979 18.375 4.05827 18.0889C3.56435 17.8372 3.16278 17.4356 2.91111 16.9417C2.625 16.3802 2.625 15.6451 2.625 14.175V6.825C2.625 5.35486 2.625 4.61979 2.91111 4.05827C3.16278 3.56435 3.56435 3.16278 4.05827 2.91111C4.61979 2.625 5.35486 2.625 6.825 2.625H14.175C15.6451 2.625 16.3802 2.625 16.9417 2.91111C17.4356 3.16278 17.8372 3.56435 18.0889 4.05827C18.375 4.61979 18.375 5.35486 18.375 6.825V14.175M9.1875 7.4375C9.1875 8.404 8.404 9.1875 7.4375 9.1875C6.471 9.1875 5.6875 8.404 5.6875 7.4375C5.6875 6.471 6.471 5.6875 7.4375 5.6875C8.404 5.6875 9.1875 6.471 9.1875 7.4375Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDynamicIcon);
export default __webpack_public_path__ + "static/media/dynamic-icon.89f2f1f360153e1063bf50fc69f6a008.svg";
export { ForwardRef as ReactComponent };